export default __webpack_public_path__ + "images/93812de16031017deebe02853d62128d.png";